import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { GenerateCollectRequestOrder } from 'src/app/public-website/buyer/services/generate-collect-request-order.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-instapay-order-payment',
  templateUrl: './instapay-order-payment.component.html',
  styleUrls: ['./instapay-order-payment.component.scss'],
})
export class InstapayOrderPaymentComponent implements OnInit, OnDestroy {
  public instapayForm: FormGroup;
  public errorMsg: string;
  public disableRequesting: boolean = false;
  private valueChangeSub!: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: InstaPayOrderData,
    public generateCollectRequest: GenerateCollectRequestOrder,
    private translate: TranslateService,
    private languageService: LanguageService,
    private dialogRef: MatDialogRef<InstapayOrderPaymentComponent>,
  ) {}


  ngOnInit(): void {
    this.setLang();
    this.instapayForm = new FormGroup({
      ipa: new FormControl('', [
        Validators.required,
        Validators.pattern(/^01\d{9}$|^.+@.+$/),
      ]),
    });

    this.valueChangeSub = this.instapayForm.get("ipa").valueChanges.subscribe((value) => {
      this.errorMsg = null;
    })
  }

  ngOnDestroy(): void {
    this.valueChangeSub.unsubscribe();
  }

  setLang() {
    if (localStorage.getItem('language')) {
      this.translate.use(localStorage.getItem('language'));
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(localStorage.getItem(lang));
    });
  }

  async submit() {
    this.disableRequesting = true;
    if (!this.instapayForm.valid) {
      this.errorMsg = this.instapayForm.getError('ipa');
      return;
    }

    try {
      this.generateCollectRequest.setParams({
        buyerAddress: this.instapayForm.get('ipa').value,
        trxRefNumber: this.data.refNumber,
      });

      const res = await this.generateCollectRequest.make();
      // this.data.refNumber = res.providerResponse.refNumber;
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text:
          error?.message ?? 'Something wrong happen, Please try again later.',
      });
    }
    this.disableRequesting = false;
  }

  close(){
    this.dialogRef.close();
  }
}

export type InstaPayOrderData = {
  qrCodeUrl: string;
  refNumber: string;
  providerRefNumber: string;
};
